import {Dispatch, SetStateAction} from "react";
import FiltersType from "@Pages/reviews/types/Filters.type";

export default function getUserRatingHandler(setFilters: Dispatch<SetStateAction<FiltersType>>) {
    const userRatingHandler = (rating) => {
        setFilters((prevFilters) => ({
            ...prevFilters,
            ratings: !prevFilters.ratings.includes(rating)
                ? [...prevFilters.ratings, rating]
                : prevFilters.ratings.filter((item) => item !== rating ?? item),
        }))
    }

    return userRatingHandler
}